import { jwtDecode } from "jwt-decode";

const useAuth = () => {
    const token = localStorage.getItem("token");

    let role = null;
    let roleId = null;
    let email = null;

    if (token) {
        try {
            const decoded = jwtDecode(token);

            email = decoded.sub;
            role = decoded.role;
            roleId = decoded.roleId;   // ✅ NOW EXISTS

        } catch (e) {
            console.error("Invalid token", e);
            localStorage.removeItem("token");
        }
    }

    return {
        token,
        email,
        role,
        roleId,
        isAuthenticated: !!token,
        isAdmin: role === "ROLE_ADMIN"
    };
};

export default useAuth;


// import { jwtDecode } from "jwt-decode";

// const useAuth = () => {
//     const token = localStorage.getItem("token");

//     let role = null;
//     let email = null;

//     if (token) {
//         try {
//             const decoded = jwtDecode(token);

//             // From backend JWT
//             email = decoded.sub;            // subject = email
//             role = decoded.role || null;    // e.g. ROLE_ADMIN

//         } catch (e) {
//             console.error("Invalid token", e);
//             localStorage.removeItem("token");
//         }
//     }

//     return {
//         token,
//         email,
//         role,
//         isAuthenticated: !!token,
//         isAdmin: role === "ROLE_ADMIN"
//     };
// };

// export default useAuth;
